import {Component, Input, OnInit, OnDestroy} from '@angular/core';
import { ShareDataService} from '@signature-it/ngx-generic/services';
import {EntityConfig} from '@signature-it/ngx-generic/config';
import {GalleryLayout} from '@signature-it/ngx-generic/enums';
import {PageRelatedItemPreviewEntityConfig, SolrOptionsEntityDTO} from "@signature-it/ngx-entity/models";
import {EntityService, SolrEntityService, EntityPageService} from "@signature-it/ngx-entity/services";
import * as EntityActions from '@signature-it/ngx-entity/store/actions';
import { EntitySelectors } from '@signature-it/ngx-entity/store/selectors';
import {Store} from "@ngrx/store";
import {Observable, Subject} from "rxjs";

declare let _ : any;
@Component({
    selector: 'page-related-item-preview',
    templateUrl: './page-related-item-preview.component.html',
    styleUrls: ['./page-related-item-preview.component.scss'],
    standalone: false
})
export class PageRelatedItemPreviewComponent implements OnInit, OnDestroy {
    @Input() key: number;
    items: any;
    templates;
    pageData: PageRelatedItemPreviewEntityConfig;
    GalleryLayout = GalleryLayout;
    gridInfo = {};
    templates$: Observable<any>;
    loadingTpl$: Observable<boolean>;
    protected destroy$: Subject<void> = new Subject<void>();

    constructor( protected entityService: EntityService,
                 protected solrEntityService: SolrEntityService,
                 protected sharedSvc: ShareDataService,
                 protected entityPageService: EntityPageService,
                 protected store$: Store<any>) {
        this.templates$ = this.store$.select(EntitySelectors.getPreviews);
        this.loadingTpl$ = this.store$.select(EntitySelectors.getIsLoadingPreviews);
    }

    ngOnInit() {
        this.store$.dispatch(EntityActions.getPreviews());
        this.pageData = PageRelatedItemPreviewEntityConfig.create(EntityConfig.ngxPageRelatedItemPreview[this.key]);
        if(this.entityPageService.mainEntity && this.pageData.relatedItemSolrKey) {
            const relatedItemsVar = this.entityPageService.mainEntity[this.pageData.relatedItemSolrKey];
            this.solrEntityService.getSolrEntityByVarList(relatedItemsVar).subscribe(items => {
                this.items = items['response']['docs'].sort((a, b) => {
                    return relatedItemsVar.indexOf(a.entity_var_s) -  relatedItemsVar.indexOf(b.entity_var_s)
                });
            })
        } else if(this.pageData.relatedEntityVarList) {
            this.solrEntityService.getSolrEntityByVarList(this.pageData.relatedEntityVarList).subscribe(items => {
                this.items = items['response']['docs'];
            })
        } else if (this.pageData.relatedEntitySolrFq) {
            let options = SolrOptionsEntityDTO.create({
                extraQryString: this.pageData.relatedEntitySolrFq
            });
            this.solrEntityService.buildSolrUrl(options).subscribe(items => {
                this.items = items['response']['docs'];
            })
        }
        this.setGridInfo();
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    setGridInfo() {
        let responsiveKeys = _.keys(this.pageData.responsive);
        const currentKey = this.sharedSvc.getCurrentBp(responsiveKeys);
        this.gridInfo =  this.pageData.responsive[currentKey] || {};
    }
}
